import * as Namespaces from './namespaces'

const locales = {
	[Namespaces.LOANS_APPLICATION]: {
		el: {
			'Borrower Information': 'Στοιχεία Δανειολήπτη',
			'No fields have been filled out': 'Δεν έχετε συμπληρώσει κανένα πεδίο',
			'There are missing fields': 'Υπάρχουν ελλείψεις',
			'Incorrect completion': 'Λάθος συμπλήρωση',
			'Completed successfully': 'Ολοκληρωμένη συμπλήρωση',
			'Close': 'Ακύρωση',
			'Delete': 'Διαγραφή',
			'Reset': 'Καθαρισμός',
			'Help': 'Βοήθεια',
			'View': 'Προβολή',
			'Confirm': 'Επιβεβαίωση',
			'Sending':'Αποστολή',
			'Copy':'Αντιγραφή',
			'Return': 'Επιστροφή',
			'Calculations': 'Υπολογισμοί',
			'Loan calculator': 'Υπολογισμός δόσης',
			'Home Page': 'Αρχική Σελίδα',
			'Actions': 'Επιλογές',
			'Details': 'Λεπτομέρειες',
			'Edit': 'Επεξεργασία',
			'Submit': 'Υποβολή',
			'Required': 'Απαιτείται',
			'Invalid email': 'Μη έγκυρο email',
			'Must be a number': 'Πρέπει να είναι αριθμός',
			'Created': 'Δημιουργήθηκε',
			'Loan purpose': 'Σκοπός Δανείου',
			"Bank": 'Τράπεζα',
			"Copy Application Data": "Αντιγραφή Στοιχείων Αίτησης",

			"Select the loan application you want to copy": "Επιλέξτε την αίτηση του δανείου που θέλετε να αντιγράψετε",
			"Save": "Αποθήκευση",
			"Temporary saving of the application data": "Προσωρινή αποθήκευση των στοιχείων της αίτησης",
			"Cancel": "Ακύρωση",
			"Your loan has been submitted successfully": "Το δάνειό σας αποθηκεύτηκε με επιτυχία",
			"Your application has been submitted successfully and is under review": "Η αίτησή σας υποβλήθηκε με επιτυχία και βρίσκεται υπό επεξεργασία",
			"Your application has been temporarily saved.": "Η αίτηση σας έχει αποθηκευτεί προσωρινά",
			"Not all required fields have been filled in or a field contains an invalid value": "Δεν έχουν συμπληρωθεί όλα τα απαραίτητα πεδία ή κάποιο πεδίο περιέχει μη έγκυρη τιμή.",

			"Something went wrong. Please try again or contact support.": "Κάτι πήγε στραβά. Παρακαλούμε δοκιμάστε ξανά ή επικοινωνήστε με την υποστήριξη",
			"from": "από",
			"Warning": "Προσοχή",
			"You have unsaved changes. Are you sure you want to close the form and lose your modifications?": "Δεν έχετε αποθηκεύσει τις μεταβολές σας. Είστε σίγουροι ότι θέλετε να κλείσετε τη φόρμα και να χάσετε τα δεδομένα;",
			"Your session has expired and you have not saved your changes. Would you like to extend your session?": "Ο χρόνος της συνεδρίας σας έχει λήξει και δεν έχετε αποθηκεύσει τις μεταβολές σας. Θα θέλατε να ανανεώσετε τον χρόνο σας;",
			"Extend Session" : "Ανανέωση χρόνου",
			"Close without saving": "Κλείσιμο χωρίς αποθήκευση",
			"Invalid format": "Μη έγκυρη μορφή",
		}, 
		en: {
			'documents': 'Documents'
		}
	},
}

export default locales